// function openNewsletterPopup() {
//   const newsletterPopup = document.querySelector('modal-box.popup--newsletter');
//   const triggerWrapper = document.querySelector('.popup_gift_button');

//   if (newsletterPopup) {
//     newsletterPopup.style.display = 'block';
//     newsletterPopup.show?.();

//     // Hide the trigger button wrapper
//     triggerWrapper.style.display = 'none';

//     // Save localStorage info
//     localStorage.setItem(
//       newsletterPopup._modalKey,
//       JSON.stringify({
//         shown: new Date().getTime(),
//         content: newsletterPopup._modalText,
//       })
//     );

//     // Show the trigger when popup closes
//     const observer = new MutationObserver(() => {
//       if (getComputedStyle(newsletterPopup).display === 'none') {
//         triggerWrapper.style.display = 'inline-block'; // or 'block'
//         observer.disconnect();
//       }
//     });

//     observer.observe(newsletterPopup, {
//       attributes: true,
//       attributeFilter: ['style']
//     });
//   }
// }

// document.getElementById('newsletter-trigger')?.addEventListener('click', openNewsletterPopup);

  // Just hide on close click — will reappear on refresh
  document.querySelector('.custom_button_close')?.addEventListener('click', function () {
    document.querySelector('.popup_gift_button').style.display = 'none';
  });

  // Newsletter popup logic (optional)
  function openNewsletterPopup() {
    const newsletterPopup = document.querySelector('modal-box.popup--newsletter');
    const triggerWrapper = document.querySelector('.popup_gift_button');

    if (newsletterPopup) {
      newsletterPopup.style.display = 'block';
      newsletterPopup.show?.();

      // Hide the trigger button wrapper
      triggerWrapper.style.display = 'none';

      // Save modal state (optional use)
      localStorage.setItem(
        newsletterPopup._modalKey,
        JSON.stringify({
          shown: new Date().getTime(),
          content: newsletterPopup._modalText,
        })
      );

      // Show the trigger when popup closes
      const observer = new MutationObserver(() => {
        if (getComputedStyle(newsletterPopup).display === 'none') {
          triggerWrapper.style.display = 'inline-block'; // or 'block'
          observer.disconnect();
        }
      });

      observer.observe(newsletterPopup, {
        attributes: true,
        attributeFilter: ['style']
      });
    }
  }

  document.getElementById('newsletter-trigger')?.addEventListener('click', openNewsletterPopup);